var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", fullscreen: "", "hide-overlay": "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("v-card", [
        _c("div", { attrs: { id: "mainDiv" } }, [
          _c("div", { attrs: { id: "headerDialog" } }, [
            _c("div", { staticStyle: { "margin-left": "2%" } }, [
              _c("h2", { staticClass: "textstyle" }, [
                _vm._v("Activar - Desactivar Conductores")
              ])
            ]),
            _c(
              "div",
              { staticStyle: { "margin-left": "auto", "margin-right": "0" } },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", dark: "" },
                    on: { click: _vm.closeDialog }
                  },
                  [_c("v-icon", [_vm._v("close")])],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { attrs: { id: "bodyDialog" } }, [
            _c("div", { attrs: { id: "centerBodyDialog" } }, [
              _c("div", { staticStyle: { height: "90%", display: "flex" } }, [
                _c(
                  "div",
                  { staticStyle: { height: "100%", width: "50%" } },
                  [
                    _c(
                      "v-card",
                      { staticStyle: { height: "100%", width: "95%" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "10%",
                              "text-align": "-webkit-center"
                            }
                          },
                          [
                            _c("v-text-field", {
                              staticStyle: { width: "80%" },
                              attrs: {
                                label: "Buscar activados...",
                                "single-line": "",
                                "hide-details": ""
                              },
                              on: { input: _vm.searchActiveDrivers }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { height: "80%" } },
                          [
                            _c("v-subheader", [_vm._v("ACTIVADOS")]),
                            _c(
                              "div",
                              {
                                staticClass: "gridcard rounded-card",
                                staticStyle: { width: "100%", height: "90%" }
                              },
                              [
                                _c("ag-grid-vue", {
                                  staticClass: "ag-theme-material",
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%"
                                  },
                                  attrs: { gridOptions: _vm.gridOptionsActived }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "10%",
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center"
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticStyle: { color: "white" },
                                attrs: {
                                  color: "#27488e",
                                  disabled: _vm.selectedRowsActived
                                },
                                on: { click: _vm.deactivateDrivers }
                              },
                              [
                                _vm._v("Pasar a desactivados"),
                                _c("v-icon", { attrs: { right: "" } }, [
                                  _vm._v(
                                    "\n                      arrow_forward\n                    "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { height: "100%", width: "50%" } },
                  [
                    _c(
                      "v-card",
                      { staticStyle: { height: "100%", width: "95%" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "10%",
                              "text-align": "-webkit-center"
                            }
                          },
                          [
                            _c("v-text-field", {
                              staticStyle: { width: "80%" },
                              attrs: {
                                label: "Buscar desactivados...",
                                "single-line": "",
                                "hide-details": ""
                              },
                              on: { input: _vm.searchDeactiveDrivers }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { height: "80%" } },
                          [
                            _c("v-subheader", [_vm._v("DESACTIVADOS")]),
                            _c(
                              "div",
                              {
                                staticClass: "gridcard rounded-card",
                                staticStyle: { width: "100%", height: "90%" }
                              },
                              [
                                _c("ag-grid-vue", {
                                  staticClass: "ag-theme-material",
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%"
                                  },
                                  attrs: {
                                    gridOptions: _vm.gridOptionsDeactived
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "10%",
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center"
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticStyle: { color: "white" },
                                attrs: {
                                  color: "#27488e",
                                  disabled: _vm.selectedRowsDeactived
                                },
                                on: { click: _vm.activateDrivers }
                              },
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v(" arrow_back ")
                                ]),
                                _vm._v("Pasar a\n                    activados")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }